"use client";

import React from "react";
import { CircleCheck, Map, Search, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  phase: "ETAPE.01",
  title: "Audit & Diagnostic",
  description: "Analyse approfondie de votre situation actuelle, de vos pratiques et identification de vos besoins spécifiques en formation.",
  icon: Search
}, {
  phase: "Etape 2",
  title: "Stratégie & Plan",
  description: "Élaboration d'un parcours sur mesure et choix des référentiels adaptés (RNCP, RS, Qualiopi) pour votre structure.",
  icon: Map
}, {
  phase: "Etape 3",
  title: "Mise en œuvre",
  description: "Accompagnement opérationnel pas à pas, création des supports documentaires et structuration de vos processus.",
  icon: Wrench
}, {
  phase: "Etape 4",
  title: "Bilan & Suivi",
  description: "Préparation intensive à l'audit, vérification de la conformité et suivi personnalisé post-certification.",
  icon: CircleCheck
}];
export default function MySupport() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}